export const PO_DOC_ERROR_TYPE = {
  INVALID_FORMAT: 'invalid_format',
  SIZE_EXCEEDED:  'size_exceeded',
  UPLOAD_FAILED:  'upload_failed',
} as const;

export type PoDocErrorType = typeof PO_DOC_ERROR_TYPE[keyof typeof PO_DOC_ERROR_TYPE] | null;

export const PO_DOC_FALLBACKS = {
  ALLOWED_MIMES: ['application/pdf'] as string[],

  INVALID_FORMAT_BANNER: 'Formato no admitido.',
  INVALID_FORMAT_ALERT: 'Only PDF files are accepted.',

  SIZE_EXCEEDED_BANNER: 'El archivo supera el límite permitido.',
  SIZE_EXCEEDED_ALERT: 'File exceeds the maximum allowed size.',

  UPLOAD_FAILED_BANNER: 'Ha ocurrido un error interno al guardar su documento.',
  UPLOAD_FAILED_ALERT: 'Error uploading document. Please try again.',

  UPLOAD_COMPLETE: 'Document uploaded successfully.',

  FILE_REQUIRED_BANNER: 'Please upload a PDF file',
} as const;
